
const digest = 'cdf002e95b98af39fe64251544f92a7958d623e0bbbecfd877ff0cf673038b82';
const classes = {"wrapper":"_wrapper_1f9wn_1","controls":"_controls_1f9wn_7","text":"_text_1f9wn_13","buttonsWrapper":"_buttonsWrapper_1f9wn_20","content":"_content_1f9wn_26"};
const css = `._wrapper_1f9wn_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_1f9wn_1 ._controls_1f9wn_7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
._wrapper_1f9wn_1 ._controls_1f9wn_7 ._text_1f9wn_13 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  font-size: 14px;
}
._wrapper_1f9wn_1 ._controls_1f9wn_7 ._buttonsWrapper_1f9wn_20 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}
._wrapper_1f9wn_1 ._content_1f9wn_26 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  